import { Helmet } from "react-helmet-async";

const SITE_ORIGIN = "https://samoony.com";

export function PageHead({
    title,
    description,
    canonicalPath,
    noindex = false,
    follow = true,
}) {
    const canonicalUrl = canonicalPath
        ? `${SITE_ORIGIN}${canonicalPath}`
        : null;
    const robots = noindex
        ? follow
            ? "noindex, follow"
            : "noindex, nofollow"
        : null;
    return (
        <Helmet>
            {title ? <title>{title}</title> : null}
            {description ? (
                <meta name="description" content={description} />
            ) : null}
            {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
            {robots ? <meta name="robots" content={robots} /> : null}
        </Helmet>
    );
}

export default PageHead;
